import { render } from "./LoginPassword.vue?vue&type=template&id=449b6cfa"
import script from "./LoginPassword.vue?vue&type=script&lang=js"
export * from "./LoginPassword.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__